import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "./home")
    },
    {
        path: "/bulma",
        name: "bulma",
        component: () => import(/* webpackChunkName: "bulma" */ "./bulma")
    },
    { path: "*", redirect: { name: "home" } }
]

const router = new VueRouter({ routes })

export default router